try{self['workbox:broadcast-update:4.3.1']&&_()}catch(e){}// eslint-disable-line